import React, { Component } from 'react';
import NavBarInverted from '../../components/nav/NavBarInverted.component.jsx';
import who from '../../assets/images/center/who-img.png';
import whoLow from '../../assets/images/center/who-img-low.png';
import enWho from '../../assets/images/center/who-img-eng.png';
import enWhoLow from '../../assets/images/center/who-img-eng-low.png';
import FooterLarge from '../../components/footer/FooterLarge.jsx';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Sponsors from './Sponsors';
import Team from './Team';
import Word from './Word';
import Statement from './Statement';
import FooterHover from '../../components/footer/FooterHover.jsx';
import Vision from './Vision';
import i18next from 'i18next';
class Center extends Component {
    constructor(props) {
        super(props);

        this.state = { imageStatus: 'loading' };
    }
    componentDidMount() {
        window.scrollTo(0, 0);
        if (i18next.language === 'ar') {
            document.getElementsByTagName('html')[0].setAttribute('lang', 'ar');
            document.getElementsByTagName('html')[0].setAttribute('dir', 'rtl');
            document.getElementById('root').style.textAlign = 'right';
            document.getElementById('root').dir = 'rtl';
        } else if (i18next.language === 'en') {
            document.getElementsByTagName('html')[0].setAttribute('lang', 'en');
            document.getElementsByTagName('html')[0].setAttribute('dir', 'ltr');
            document.getElementById('root').style.textAlign = 'left';
            document.getElementById('root').dir = 'ltr';
        }
    }

    handleImageLoaded = () => {
        this.setState({ imageStatus: 'loaded' });
    };

    handleImageErrored = () => {
        this.setState({ imageStatus: 'failed to load' });
    };

    render() {
        return (
            <div>
                <div className='center-container'>
                    <NavBarInverted big center />
                    <div className='center-row'>
                        <Statement />
                        <div className='who-img-container'>
                            {this.state.imageStatus === 'loading' ? (
                                <>
                                    {i18next.language === 'ar' ? (
                                        <LazyLoadImage
                                            src={whoLow}
                                            className={`who-img ${
                                                this.state.imageStatus ===
                                                'loaded'
                                                    ? 'low-qualit'
                                                    : ''
                                            }`}
                                            alt='who-img'
                                            onLoad={this.handleImageLoaded}
                                            onError={this.handleImageErrored}
                                        />
                                    ) : (
                                        <LazyLoadImage
                                            src={enWhoLow}
                                            className={`who-img ${
                                                this.state.imageStatus ===
                                                'loaded'
                                                    ? 'low-qualit'
                                                    : ''
                                            }`}
                                            alt='who-img'
                                            onLoad={this.handleImageLoaded}
                                            onError={this.handleImageErrored}
                                        />
                                    )}
                                </>
                            ) : (
                                <>
                                    {i18next.language === 'ar' ? (
                                        <LazyLoadImage
                                            src={who}
                                            className='who-img'
                                            alt='who-img'
                                            onLoad={this.handleImageLoaded}
                                            onError={this.handleImageErrored}
                                        />
                                    ) : (
                                        <LazyLoadImage
                                            src={enWho}
                                            className='who-img'
                                            alt='who-img'
                                            onLoad={this.handleImageLoaded}
                                            onError={this.handleImageErrored}
                                        />
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                    <Vision />
                    <Word />
                    <Team />
                    <Sponsors />
                </div>
                <FooterLarge minimal />
                <FooterHover />
            </div>
        );
    }
}

export default Center;
